module.exports = __webpack_public_path__ + "static/media/fastGamesPlayed_1000_5000.d6fe266c.png";